import Blogs from "./components/Blogs/Blogs";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Navigation from "./components/Navigation/Navigation";
import Search from "./components/Search/Search";

function App() {
  return (
    <div>
      <Navigation />
      <Search />
      <section class="relative bg-gray-50 pt-8 pb-15 px-4 sm:px-6 lg:pt-16 lg:pb-16 lg:px-8">
        <div className="absolute inset-0">
          <div className="bg-white h-1/3 sm:h-2/3"></div>
        </div>
        <div className="relative max-w-7xl mx-auto">
          <Header />
          <Blogs />
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default App;
